/** Recognize whole-field web addresses without turning prose or email into links. */
export function fieldWebURL(value: string): string | undefined {
  const text = value.trim();
  if (!text || /[\s\\]/u.test(text)) return undefined;
  const explicit = /^https?:\/\//i.test(text);
  if (!explicit && !/^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}(?::\d+)?(?:[/?#]|$)/i.test(text)) return undefined;
  try {
    const url = new URL(explicit ? text : `https://${text}`);
    if (!url.hostname || url.username || url.password) return undefined;
    return url.href;
  } catch {
    return undefined;
  }
}

export function FieldLink({ value }: { value: string }) {
  const href = fieldWebURL(value);
  return href ? <a href={href} target="_blank" rel="noopener noreferrer" onClick={event => event.stopPropagation()}>{value}</a> : <>{value}</>;
}
